import { Link } from "gatsby";
import React, { useContext, useEffect, useState } from "react";
import "./styles/Footer.css";

import styled from 'styled-components';
import facebook from "../assets/facebook.svg";
import logo from "../assets/footer-logo.svg";
import instagram from "../assets/instagram.svg";
import youtube from "../assets/youtube.svg";
import { ApiContext } from "../contexts/ApiContext";

const NewletterSubmitButton = styled.button`
  padding: 10px 20px;
  cursor: pointer;
  width: 100%;
  background-color: #006bd6;
  color: #ffffff;
  font-weight: 600;
  border-radius: 5px;
  border: none;
  transition: background-color 0.3s;
  text-transform: uppercase;

  &:hover {
    background-color: #5983ff !important;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: #cccccc;
  }
`;

const TeamBox = styled.div`
  padding: 0.5rem;
  margin-top: 8px;
  border: 1px solid white;
  color: white;
  font-size: 16px;

  & .teamTitle {
    padding-bottom: 6px;
  }
  & .teamContent {
    padding: 4px 0;
  }
  & .teamLink {
    color: #fff;
    text-decoration: underline !important;
  }

  @media (max-width: 768px) {
    margin-top: 2rem;
  }
`;

const FooterBox = styled.footer`
  background: rgb(90, 90, 90);
  display: grid;
  grid-template-columns: repeat(6, 1fr);  
  z-index: 100;
  gap: 2rem;
  padding: 4rem 0;
  
  & .footer-logo {
    width: 190px;
  }

  & .footer-row {
    width: 100%;
    min-width: 220px;
  }
  & .footer-row-follow {
    flex-direction: column;
  }
  & .footer-link-container {
    display: flex;
    flex-direction: column;
    gap: 3px;
    margin-top: 13px;
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(1, 1fr);

    & .footer-logo {
      margin-left: -50px;
    }
    & .footer-row {
      justify-content: center;
      align-items: center;
      display: flex;
    }
    & .footer-link-container {
      text-align: center;
    }
  }
`;

const NewsletterContainer = styled.section`
  width: 100%;
  max-width: 600px;
  padding:  0 1rem;
  display: block !important;
  color: #fff;
  grid-column: span 3;
  box-sizing: border-box;
  margin: 0 auto;

  @media (max-width: 1024px) {
    grid-column: span 1;
  }
`;

const Footer = () => {
  const { conditions, services } = useContext(ApiContext);
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await fetch('https://api.constantcontact.com/v2/contacts', {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer da33aa27-1dca-4e63-bb9c-43fec8323b50',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email_addresses: [{
            email_address: email,
            permission_to_send: 'explicit'
          }],
          lists: [{
            id: '3eb54a90-81b9-11ef-9e2e-fa163ed0f319'
          }]
        })
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    }
    
    setIsSubmitting(false);
  };

  useEffect(() => {
    // Check if the script is already present
    if (!document.getElementById("signupScript")) {
      // Create a new script element
      const script = document.createElement("script");
      script.id = "signupScript";
      script.src =
        "//static.ctctcdn.com/js/signup-form-widget/current/signup-form-widget.min.js";
      script.onload = () => {
        if (window.initializeCtct) {
          window.initializeCtct();
        }
      };
      document.body.appendChild(script);
    } else {
      // If script is already present, re-initialize
      if (window.initializeCtct) {
        window.initializeCtct();
      }
    }
  }, []);

  // alphabetize conditions
  const alphabetcondtions = conditions.sort((a, b) => {
    if (a.title < b.title) {
      return -1;
    } else {
      return 1;
    }
  });

  const alphabetServices = services.Services?.sort((a, b) => {
    if (a.title < b.title) {
      return -1;
    } else {
      return 1;
    }
  });
  return (
    <FooterBox>
      <section className="footer-row logo-row">
        <a href="/" alt="go to home">
          <img src={logo} className="footer-logo" alt="logo" />
        </a>
      </section>
      <NewsletterContainer>
        <div 
          className="ctct-inline-form"
          style={{ 
            minHeight: "200px", 
            width: "100%",
            display: "block",
            visibility: "visible",
            opacity: 1
          }}
        >
        <h3>Newsletter</h3>
        <p>Subscribe to out newsletter and stay updated.</p>
        <form 
          onSubmit={handleSubmit}
          style={{ 
            minHeight: "200px", 
            width: "100%",
            display: "block",
            visibility: "visible",
            opacity: 1
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: "column",
            }}>
            <label htmlFor="email" style={{paddingBottom: "5px", fontWeight:"bold"}}><span style={{color:"red", fontSize: "18px", marginRight: "2px"}}>*</span>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              style={{
                padding: '10px',
                width: '100%',
                marginRight: '10px',
                boxSizing: 'border-box',
                borderRadius: '5px',
                border: 'none',
              }}
            />
          </div>
          <p style={{fontSize: "12px", margin: "20px 0"}}>By submitting this form, you are consenting to receive marketing emails from: New York Gastroenterology Associates. You can revoke your consent to receive emails at any time by using the SafeUnsubscribe&copy; link found at the bottom of every email. Emails are serviced by Constant Contact.</p>
          <NewletterSubmitButton type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Subscribing...' : 'Subscribe'}
          </NewletterSubmitButton>
          {submitStatus === 'success' && (
            <p style={{ color: 'green' }}>Successfully subscribed!</p>
          )}
          {submitStatus === 'error' && (
            <p style={{ color: 'red' }}>Something went wrong. Please try again.</p>
          )}
        </form>
        </div>
      </NewsletterContainer>
    

      <section className="footer-row">
        <div className="footer-link-container">
          <Link to="/disclosures" className="footer-link">
            Disclosures
          </Link>
          <Link to="/privacy-policy" className="footer-link">
            Privacy Policy
          </Link>

          <Link to="/terms-conditions" className="footer-link">
            Terms & Conditions
          </Link>

          <TeamBox>
            <div className="teamTitle">Join Our Team</div>
            <div className="teamContent">Please send your resume to</div>
            <a className="teamLink" href="mailto:careers@nygahealth.com">careers@nygahealth.com</a>
          </TeamBox>
        </div>
      </section>

      <section className="footer-row footer-row-follow">
        <span className="footer-links visit-link">FOLLOW US</span>
        <div className="footer-media-container">
          <a
            href="https://www.instagram.com/newyorkgastro/"
            className="footer-media instagram"
            target="_blank"
            rel="noreferrer"
          >
            <img src={instagram} alt="instagram" />
          </a>

          <a
            href="https://www.facebook.com/newyorkgastro"
            className="footer-media facebook"
            target="_blank"
            rel="noreferrer"
          >
            <img src={facebook} alt="facebook" />
          </a>
          <a
            href="https://www.youtube.com/channel/UCZwS_2rzXxHdIm_xkQb2b9A"
            className="footer-media youtube"
            target="_blank"
            rel="noreferrer"
          >
            <img src={youtube} alt="youtube" />
          </a>
        </div>
      </section>

      <div className="hidden-link-container">
        <Link to="/WestsideGastro-Joins-NYGA">
          Link to west side gastro page
        </Link>

        <Link to="/ErberJoinsNYGA">Link to Erber Splash</Link>
      </div>
    </FooterBox>
  );
};

export default Footer;
